import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Layers, Lock } from 'lucide-react';
export function SolutionSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-183">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-184"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-600/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-185"></div>

      <div className="relative z-10 flex flex-col md:flex-row items-center gap-12" data-id="element-186">
        <div className="flex-1" data-id="element-187">
          <div className="inline-block px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/10 text-amber-400 font-semibold text-sm mb-6" data-id="element-188">
            Presentando Barrier Shield Technology™
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-189">
            Ingeniería de Capas: <br data-id="element-190" />
            <span className="text-amber-400" data-id="element-191">El Escudo de Cristal</span>
          </h2>
          <p className="text-stone-300 text-lg mb-8 leading-relaxed" data-id="element-192">
            He decodificado la técnica de las altas pastelerías francesas para
            que puedas replicarla en tu casa. No necesitas herramientas
            costosas, necesitas entender la ciencia.
          </p>

          <ul className="space-y-6" data-id="element-193">
            <li className="flex items-start gap-4" data-id="element-194">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-195">
                <Lock className="w-5 h-5 text-amber-400" data-id="element-196" />
              </div>
              <div data-id="element-197">
                <h4 className="text-white font-bold text-lg" data-id="element-198">
                  Sellado Térmico
                </h4>
                <p className="text-stone-400" data-id="element-199">
                  Aprenderás a crear una barrera invisible de azúcar
                  caramelizada que actúa como un cristal.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-200">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-201">
                <Layers className="w-5 h-5 text-amber-400" data-id="element-202" />
              </div>
              <div data-id="element-203">
                <h4 className="text-white font-bold text-lg" data-id="element-204">
                  Aislamiento de Humedad
                </h4>
                <p className="text-stone-400" data-id="element-205">
                  Impide físicamente que la humedad de la crema toque las capas
                  de hojaldre.
                </p>
              </div>
            </li>
            <li className="flex items-start gap-4" data-id="element-206">
              <div className="mt-1 bg-amber-500/20 p-2 rounded-lg" data-id="element-207">
                <CheckCircle2 className="w-5 h-5 text-amber-400" data-id="element-208" />
              </div>
              <div data-id="element-209">
                <h4 className="text-white font-bold text-lg" data-id="element-210">
                  Durabilidad Extrema
                </h4>
                <p className="text-stone-400" data-id="element-211">
                  Tu Mil Hojas se mantendrá crujiente por 48 horas, incluso en
                  climas húmedos.
                </p>
              </div>
            </li>
          </ul>
        </div>

        <div className="flex-1 w-full" data-id="element-212">
          <div className="bg-stone-800 border border-stone-700 rounded-2xl p-8 relative overflow-hidden group hover:border-amber-500/50 transition-colors duration-300" data-id="element-213">
            <div className="absolute top-0 right-0 bg-amber-500 text-stone-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-214">
              MÉTODO PRO
            </div>

            <h3 className="text-2xl font-serif text-white mb-6" data-id="element-215">
              Lo que vas a lograr
            </h3>

            <div className="space-y-4" data-id="element-216">
              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-217">
                <span className="text-stone-300" data-id="element-218">Crujido (Decibelios)</span>
                <div className="flex items-center gap-2" data-id="element-219">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-220">
                    <div className="h-full bg-amber-500 w-[95%]" data-id="element-221"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-222">
                    ALTO
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-223">
                <span className="text-stone-300" data-id="element-224">Integridad Estructural</span>
                <div className="flex items-center gap-2" data-id="element-225">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-226">
                    <div className="h-full bg-amber-500 w-[100%]" data-id="element-227"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-228">
                    100%
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-stone-900/50 rounded-lg border border-stone-700" data-id="element-229">
                <span className="text-stone-300" data-id="element-230">Tiempo de Vida</span>
                <div className="flex items-center gap-2" data-id="element-231">
                  <div className="w-24 h-2 bg-stone-700 rounded-full overflow-hidden" data-id="element-232">
                    <div className="h-full bg-amber-500 w-[90%]" data-id="element-233"></div>
                  </div>
                  <span className="text-amber-400 font-mono font-bold" data-id="element-234">
                    48H+
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-stone-700 text-center" data-id="element-235">
              <p className="text-stone-400 italic" data-id="element-236">
                "Es como ponerle un impermeable invisible a tu postre"
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}